<template>
    <div>
        <DataTable
                   :value="logs"
                   :lazy="true"
                   :paginator="true"
                   :rows="5"
                   dataKey="id"
                   :totalRecords="totalRecords"
                   :loading="loading"
                   @page="onPage($event)"
                   removableSort
                   sortMode="multiple"
                   responsiveLayout="scroll"
                   :rowClass="rowClass"
                   :rowStyle="rowStyle"
                   paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No logs available </template>
            <template #paginatorstart>
                <Button type="button" icon="pi pi-refresh" text @click="loadLogs(1, 5)" />
            </template>
            <template #paginatorend />
            <Column field="event.description" header="Event" />
            <Column header="Event Date" >
                <template #body="slotProps">
                    {{dateFormat(slotProps.data.updated_at)}}
                </template>
            </Column>
            <Column header="User" >
                <template #body="slotProps">
                    <a :href="'mailto:'+ slotProps.data.author.email">
                    {{slotProps.data.author.name}}
                    {{slotProps.data.author.surname}}
                    </a>
                </template>
            </Column>
            <Column header="Details">
                <template #body="slotProps">
                    <Button
                        v-if="
                            slotProps.data.details.length > 0 &&
                            slotProps.data.event.code !== 'task_open' &&
                            slotProps.data.event.code !== 'task_comment_open' &&
                            slotProps.data.event.code !== 'incident_create' &&
                            slotProps.data.event.code !== 'incident_open' &&
                            slotProps.data.event.code !== 'debrief_create' &&
                            slotProps.data.event.code !== 'debrief_open' &&
                            slotProps.data.event.code !== 'learning_outcome_open' &&
                            slotProps.data.event.code !== 'learning_outcome_create'
                            "
                        icon="pi pi-folder-open"
                        severity="help"
                        rounded
                        outlined
                        aria-label="Details"
                        v-tooltip="'Click to see the details.'"
                        :badge="slotProps.data.details.length.toString()"
                        @click="displayDetailDialog(slotProps.data.details, slotProps.data.updated_at, slotProps.data.event.description, slotProps.data.id)"
                    />
                    <i v-else class="pi pi-folder ml-3" v-tooltip="'No detail for this entry.'"></i>

                </template>
            </Column>
        </DataTable>
    </div>


    <Dialog v-model:visible="logDetailsPopup" :header="logDetailsPopupTitle" :style="{ width: '70rem' }" @hide="hideDetailPopup" modal>
            <DataTable
                :value="logDetailData"
                :lazy="false"
                :paginator="false"
                dataKey="id"
                :totalRecords="logDetailData.length"
                :loading="loading"
                removableSort
                stripedRows
                sortMode="multiple"
                responsiveLayout="scroll"
            >
                <template #empty> No logs available </template>
                <Column field="event.description" header="Field" >
                    <template #body="slotProps">
                        <div v-if="slotProps.data.field === 'attachment' || slotProps.data.field === 'taskCommentFiles'">
                            <span class='pi pi-download'></span> Attachment
                        </div>
                        <div v-else-if="slotProps.data.field === 'users_notified'">
                            <span class='pi pi-users'></span> User notified
                        </div>
                        <div v-else-if="slotProps.data.field === 'task_notified'">
                            <span class='pi pi-users'></span> User notified
                        </div>
                        <div v-else-if="slotProps.data.field === 'users_assigned_to'">
                            <span class='pi pi-users'></span> User assigned to
                        </div>
                        <div v-else-if="slotProps.data.field === 'task'">
                            <span class='pi pi-align-left'></span> Task
                        </div>
                        <div v-else-if="slotProps.data.field === 'task_status_changed'">
                            <span class='pi pi-arrow-right-arrow-left'></span> Task status change
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskCommentText'">
                            <span class='pi pi-comments'></span> Comment
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskCommentAuthor'">
                            <span class='pi pi-user'></span> Author
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskCommentTime'">
                            <span class='pi pi-calendar'></span> Date
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskArchiveText'">
                            <span class='pi pi-comments'></span> Reason
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskArchiveAuthor'">
                            <span class='pi pi-user'></span> Author
                        </div>
                        <div v-else-if="slotProps.data.field === 'taskArchiveTime'">
                            <span class='pi pi-calendar'></span> Date
                        </div>
                        <div v-else-if="slotProps.data.field === 'incident_create'">
                            <span class='pi pi-bell'></span> Incident
                        </div>
                        <div v-else-if="slotProps.data.field === 'category'">
                            <span class='pi pi-book'></span> Category
                        </div>
                        <div v-else-if="slotProps.data.field === 'incident_date'">
                            <span class='pi pi-calendar'></span> Date
                        </div>
                        <div v-else-if="slotProps.data.field === 'company_id'">
                            <span class='pi pi-building'></span> Company
                        </div>
                        <div v-else-if="slotProps.data.field === 'incident_number'">
                            <span class='pi pi-bell'></span> Incident Number
                        </div>
                        <div v-else-if="slotProps.data.field === 'officer_in_charge'">
                            <span class='pi pi-user'></span> Officer in charge
                        </div>
                        <div v-else-if="slotProps.data.field === 'station'">
                            <span class='pi pi-home'></span> Station
                        </div>
                        <div v-else-if="slotProps.data.field === 'incident_type_id'">
                            <span class='pi pi-exclamation-triangle'></span> Incident Type
                        </div>
                        <div v-else-if="slotProps.data.field === 'property_type_id'">
                            <span class='pi pi-flag'></span> Property Type
                        </div>
                        <div v-else-if="slotProps.data.field === 'location'">
                            <span class='pi pi-map'></span> Location
                        </div>
                        <div v-else-if="slotProps.data.field === 'details'">
                            <span class='pi pi-file'></span> Details
                        </div>
                        <div v-else-if="slotProps.data.field === 'outcome_type'">
                            <span class='pi pi-file'></span> Type
                        </div>
                        <div v-else-if="slotProps.data.field === 'theme_id'">
                            <span class='pi pi-file'></span> Theme
                        </div>
                        <div v-else-if="slotProps.data.field === 'source_id'">
                            <span class='pi pi-file'></span> Source
                        </div>
                        <div v-else-if="slotProps.data.field === 'summary'">
                            <span class='pi pi-book'></span> Summary
                        </div>
                        <div v-else-if="slotProps.data.field === 'debrief_linked_to_incident'">
                            <span class='pi pi-bell'></span> Debrief linked with incident
                        </div>
                        <div v-else-if="slotProps.data.field === 'appliance_id'">
                            <span class='pi pi-car'></span> Appliance
                        </div>
                        <div v-else-if="slotProps.data.field === 'learning_outcome_linked_to_debrief'">
                            <span class='pi pi-building-columns'></span> Learning Outcome linked with Debrief
                        </div>
                        <div v-else-if="slotProps.data.field === 'task_assurance_level_changed'">
                            <span class='pi pi-building-columns'></span> Task Progress to completion changed
                        </div>
                        <div v-else>{{slotProps.data.field}}</div>
                    </template>
                </Column>
                <Column field="event.description" header="Old" >
                    <template #body="slotProps">
                        <!--slotProps.data.field: {{slotProps.data.field}}<br/>-->

                        <template v-if="slotProps.data.field === 'attachment' || slotProps.data.field === 'taskCommentFiles'">
                            <div v-for="item in slotProps.data.old" :key="item.id">
                                <a href="#" @click="downloadFile(item.id, item.original_name)">{{item.original_name}}</a>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'taskCommentAuthor'">
                            <div v-if="slotProps.data.old">
                                <a :href="'mailto:'+slotProps.data.old.email">{{slotProps.data.old.name}} {{slotProps.data.old.surname}}</a>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'taskArchiveAuthor'">
                            <div v-if="slotProps.data.old">
                                <a :href="'mailto:'+slotProps.data.old.email">{{slotProps.data.old.name}} {{slotProps.data.old.surname}}</a>
                            </div>
                        </template>
                        <div v-else-if="slotProps.data.field === 'source_id' || slotProps.data.field === 'theme_id' || slotProps.data.field === 'priority' || slotProps.data.field === 'progress'">
                            {{slotProps.data.old.description}}
                        </div>
                        <div v-else-if="slotProps.data.field === 'task_assurance_level_changed'">
                            {{ getAssuranceLabel(slotProps.data.old) }}
                        </div>
                        <template v-else-if="slotProps.data.field === 'users_notified' || slotProps.data.field === 'users_assigned_to' || slotProps.data.field === 'task_notified'">
                            <div v-for="user in slotProps.data.old" :key="user.id">
                                <a :href="'mailto:'+user.email">{{user.name}} {{user.surname}}</a>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'description' || slotProps.data.field === 'taskCommentText'">
                            <div v-html="slotProps.data.old" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'description' || slotProps.data.field === 'taskArchiveText'">
                            <div v-html="slotProps.data.old" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'task_status_changed'">
                            <div v-if="slotProps.data.old === 1">No progress</div>
                            <div v-else-if="slotProps.data.old === 2">In progress</div>
                            <div v-else-if="slotProps.data.old === 3">Completed</div>
                        </template>
                        <template v-else-if="
                            slotProps.data.field === 'debrief_linked_to_incident' ||
                            slotProps.data.field === 'learning_outcome_linked_to_debrief' "
                        >
                        </template>
                        <template v-else-if="slotProps.data.field === 'category'
                            || slotProps.data.field === 'company_id'
                            || slotProps.data.field === 'incident_type_id'
                            || slotProps.data.field === 'appliance_id'
                            || slotProps.data.field === 'property_type_id'
                        ">
                            <div v-html="slotProps.data.old.description" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'outcome_type'">
                            <div v-if="parseInt(slotProps.data.old)===1">
                                Local Issue
                            </div>
                            <div v-else-if="parseInt(slotProps.data.old)===2">
                                Service Wide
                            </div>
                            <div v-else-if="parseInt(slotProps.data.old)===3">
                                Notable Practice
                            </div>
                        </template>
                        <div v-else-if="slotProps.data.field === 'details'" v-html="slotProps.data.old" />
                        <div v-else>{{slotProps.data.old}}</div>
                    </template>
                </Column>
                <Column field="event.description" header="New" >
                    <template #body="slotProps">
                        <template v-if="slotProps.data.field === 'attachment' || slotProps.data.field === 'taskCommentFiles'">
                            <div v-for="item in slotProps.data.new" :key="item.id">
                                <a href="#" @click="downloadFile(item.id, item.original_name)">{{item.original_name}}</a>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'taskCommentAuthor'">
                            <a :href="'mailto:'+slotProps.data.new.email">{{slotProps.data.new.name}} {{slotProps.data.new.surname}}</a>
                        </template>
                        <template v-else-if="slotProps.data.field === 'taskArchiveAuthor'">
                            <a :href="'mailto:'+slotProps.data.new.email">{{slotProps.data.new.name}} {{slotProps.data.new.surname}}</a>
                        </template>
                        <template v-else-if="slotProps.data.field === 'users_notified' || slotProps.data.field === 'users_assigned_to' || slotProps.data.field === 'task_notified'">
                            <div v-for="user in slotProps.data.new" :key="user.id">
                                <a :href="'mailto:'+user.email">{{user.name}} {{user.surname}}</a>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'task'">
                            <div v-for="task in slotProps.data.new" :key="task.id">
                                {{task}}
                            </div>
                        </template>
                        <div v-else-if="slotProps.data.field === 'source_id' || slotProps.data.field === 'theme_id' || slotProps.data.field === 'priority' || slotProps.data.field === 'progress'">
                            {{slotProps.data.new.description}}
                        </div>
                        <div v-else-if="slotProps.data.field === 'task_assurance_level_changed'">
                            {{ getAssuranceLabel(slotProps.data.new) }}
                        </div>
                        <template v-else-if="slotProps.data.field === 'description' || slotProps.data.field === 'taskCommentText' ">
                            <div v-html="slotProps.data.new" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'description' || slotProps.data.field === 'taskArchiveText' ">
                            <div v-html="slotProps.data.new" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'task_status_changed'">
                            <div v-if="slotProps.data.new === 1">No progress</div>
                            <div v-else-if="slotProps.data.new === 2">In progress</div>
                            <div v-else-if="slotProps.data.new === 3">Completed</div>
                        </template>
                        <template v-else-if="
                                slotProps.data.field === 'category' ||
                                slotProps.data.field === 'company_id' ||
                                slotProps.data.field === 'incident_type_id' ||
                                slotProps.data.field === 'appliance_id' ||
                                slotProps.data.field === 'property_type_id'
                            ">
                            <div v-html="slotProps.data.new.description" />
                        </template>
                        <template v-else-if="slotProps.data.field === 'learning_outcome_linked_to_debrief'">
                            <div class="grid">
                                <div class="col-4">
                                    Learning Outcome details:
                                </div>
                                <div class="col-8" v-html="slotProps.data.new.details" />
                                <div class="col-4">
                                    Debrief:
                                </div>
                                <div class="col-8" >

                                    <router-link
                                        v-if="slotProps.data.new && slotProps.data.new.id"
                                        v-show="authStore.hasPermission(UserPermission.WRITE_DEBRIEF)"
                                        replace
                                        :to="{ name: 'DebriefCreateUpdate', query: { debriefId: slotProps.data.new.debrief_id } }"
                                    >
                                        Link
                                    </router-link>
                                </div>
                            </div>


                        </template>
                        <template v-else-if="slotProps.data.field === 'debrief_linked_to_incident'">
                            <div class="grid">
                                <div class="col-4">
                                    Incident:
                                </div>
                                <div class="col-8">
                                    <router-link
                                        v-if="slotProps.data.new && slotProps.data.new.incident_id"
                                        v-show="authStore.hasPermission(UserPermission.WRITE_INCIDENT)"
                                        replace
                                        :to="{ name: 'IncidentCreateUpdate', query: { incidentId: slotProps.data.new.incident_id } }"
                                    >
                                        Link
                                    </router-link>
                                </div>

                                <div class="col-4">
                                    Debrief:
                                </div>
                                <div class="col-8">
                                    <router-link
                                        v-if="slotProps.data.new && slotProps.data.new.id"
                                        v-show="authStore.hasPermission(UserPermission.WRITE_DEBRIEF)"
                                        replace
                                        :to="{ name: 'DebriefCreateUpdate', query: { debriefId: slotProps.data.new.id } }"
                                    >
                                        Link
                                    </router-link>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="slotProps.data.field === 'outcome_type'">
                            <div v-if="parseInt(slotProps.data.new)===1">
                                Local Issue
                            </div>
                            <div v-else-if="parseInt(slotProps.data.new)===2">
                                Service Wide
                            </div>
                            <div v-else-if="parseInt(slotProps.data.new)===3">
                                Notable Practice
                            </div>
                        </template>
                        <div v-else-if="slotProps.data.field === 'details'" v-html="slotProps.data.new" />
                        <div v-else>{{slotProps.data.new}}</div>

                    </template>
                </Column>
            </DataTable>


        <template #footer>
            <Button label="Close" severity="warning" @click="hideDetailPopup" />
        </template>

    </Dialog>
</template>

<script setup>

import { computed, defineProps, onMounted, ref, watch } from 'vue';
// import { DateTime } from 'luxon';
import { authApi } from '@/utilities/axios';
import { authStore, fileStore } from '@/store/global-stores';
import { DateTime } from 'luxon';
import { UserPermission } from '@/modules/permission/enum';
import { getAssuranceLabel } from '../constants';
import { useRoute } from 'vue-router';

const props = defineProps({
    event_code: {
        type: Array,
        required: false
    },
    event_type: {
        type: Array,
        required: false
    },
    entity_ids: {
        type: Array,
        required: true
    },
});

const logs = ref([])
const loading = ref(false)
const totalRecords = ref(0)

const logDetailsPopup = ref(false)
const logDetailsPopupTitle = ref('')
const logDetailData = ref([])
const currentLogId = ref(0)
const route = useRoute();
const rowClass = (data) => {
    return [{ 'bg-yellow-100': data.id === currentLogId.value }];
};
const rowStyle = (data) => {
    if (data.id === currentLogId.value) {
        return { fontWeight: 'bold', fontStyle: 'italic', background: 'yellow-200' };
    }
};

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

//entity_ids
watch(() => props.entity_ids, () => {
    loadLogs(1, 5)
})

onMounted(async () => {
    loadLogs(1, 5)
})

function loadLogs(requestedPage, pageSize) {
    loading.value = true

    let url = `/v2/events`
    //
    // console.log('props.event_code', props.event_code)
    // console.log('props.event_type', props.event_type)
    // console.log('props.entity_ids', props.entity_ids)

    let queryParams = {
        company_id: company_id.value,
        page: requestedPage,
        page_size: pageSize,
        paginated: true,
    }

    if (typeof props.event_code !== 'undefined' && props.event_code.length > 0) {
        queryParams.event_code = props.event_code
    }

    if (typeof props.event_type !== 'undefined' && props.event_type.length > 0) {
        queryParams.event_type = props.event_type
    }

    if (props.entity_ids.length > 0) {
        queryParams.entity_ids = props.entity_ids
    }

    queryParams.task_id = parseInt(route.params.id);

    authApi.get(url, {
            params: queryParams
        })
        .then( async (response) => {

            if (response.statusCode === 200) {

                if (Object.hasOwn(response, 'data')) {
                    if (Object.hasOwn(response.data, 'total')) {
                        totalRecords.value = response.data.total
                    }

                    if (Object.hasOwn(response.data, 'data')) {
                        logs.value = response.data.data

                    }
                }

            }
        }).finally(() => {
        loading.value = false
    })
}

function hideDetailPopup() {
    currentLogId.value = 0
    logDetailsPopup.value = false
}


const downloadFile = async (fileId, fileName) => {
    await fileStore.downloadFile(fileId, fileName);
};

function displayDetailDialog(details, date, eventDescription, logId) {

    console.log('details: ', details)
/*
    details.forEach(detail => {
        console.log('detail field: ', detail.field)

        let mappedDetails = null
        let newData = ""

        switch(detail.field) {

            case 'attachment':
                console.log("attachment details", detail)
                //<a href="#" @click="downloadFile(item?.file?.id, item?.file?.original_name)">{{ item?.file?.original_name }}</a>

                detail.new.forEach(file => {
                    newData += `<a href="#" @click="downloadFile(${file.id}, ${file.original_name})">${file.original_name}</a><br />`
                })

                mappedDetails = {
                    field: "<span class='pi pi-users'></span> User(s) assigned to",
                    old: newData,
                    new: "",
                }

                break;

            case 'users_assigned_to':

                detail.new.forEach(user => {
                    newData += `<a href='mailto:${user.email}'>${user.name} ${user.surname}</a><br />`
                })

                mappedDetails = {
                    field: "<span class='pi pi-users'></span> User(s) assigned to",
                    old: newData,
                    new: "",
                }

                break;

            case "users_notified":

                detail.new.forEach(user => {
                    newData += `<a href='mailto:${user.email}'>${user.name} ${user.surname}</a><br />`
                })

                mappedDetails = {
                    field: "<span class='pi pi-users'></span> User(s) notified to",
                    old: newData,
                    new: "",
                }

                break;
        }

        if (mappedDetails != null) {
            detailsTableData.push(mappedDetails)
        }
    })
    */
    logDetailData.value = details

    currentLogId.value = logId

    logDetailsPopupTitle.value = 'Detail: ' + eventDescription + ' of ' + dateFormat(date)

    logDetailsPopup.value = true
}

function onPage(event) {
    loadLogs(event.page + 1, event.rows)
}

function dateFormat(date) {
    return DateTime.fromISO(date)?.setLocale('en-GB').toFormat('ccc, dd LLL yyyy, HH:mm:ss')
}

</script>

<style scoped>

</style>